import { render, staticRenderFns } from "./sw-tfa-dialog.vue?vue&type=template&id=44f95d9d&scoped=true&"
import script from "./sw-tfa-dialog.vue?vue&type=script&lang=ts&"
export * from "./sw-tfa-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./sw-tfa-dialog.vue?vue&type=style&index=0&id=44f95d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f95d9d",
  null
  
)

export default component.exports